export interface IAzureSubscription {
  id: string;
  azureSubscriptionName: string;
  azurePlanId: string; // Refers to Azure Plan Id, but is considered as any other Microsoft "Subscription" Id
  status: string;
}

export default class AzureSubscription {
  private id: string;
  private azureSubscriptionName: string;
  private azurePlanId: string;
  private status: string;

  constructor(dto: IAzureSubscription) {
    Object.assign(this, dto);
  }

  get getId(): string {
    return this.id;
  }

  set setId(id: string) {
    this.id = id;
  }

  get getAzureSubscriptionName(): string {
    return this.azureSubscriptionName;
  }

  set setAzureSubscriptionName(azureSubscriptionName: string) {
    this.azureSubscriptionName = azureSubscriptionName;
  }

  get getAzurePlanId(): string {
    return this.azurePlanId;
  }

  set setAzurePlanId(azurePlanId: string) {
    this.azurePlanId = azurePlanId;
  }

  get getStatus(): string {
    return this.status;
  }

  set setStatus(status: string) {
    this.status = status;
  }
}
